const moveScreenRouter = {
  path: "/moveScreen",
  name: "moveScreen",
  component: () => import("@/views/moveScreen/index"),
  meta: {
    title: "搬家数据大屏"
  }
};

export default moveScreenRouter;
